


































































import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class UpdateDottedIcon extends Vue {
    @Prop({ default: () => 21 }) size: number;
    color = this.$store.direct.state.widget.color;
}
